export default __webpack_public_path__ + "static/media/7.377768e5.jpg";